var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('kst-section',{staticClass:"mt-5",attrs:{"items-mode":""}},[_c('kst-failure',{staticClass:"mb-4",attrs:{"data-mode":"","message":_vm.failureItems}}),_c('List',{attrs:{"userItems":_vm.userItems,"isListLoading":_vm.isListLoading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }